  <!-- Header -->
  <div class="header-top-fixed one-page-nav" [ngClass]="{'menu-open menu-open-desk' : sidebarOpen}">
    <div class="container">
        <!-- Brand -->
        <div class="logo d-none d-md-block">
            <a class="navbar-brand" >
                <!-- <img class="logo-dark" title="" alt="Donart." > -->
                <a class="logo-dark">DONART PLLASHNIKU</a>
                <a class="logo-light">DONART PLLASHNIKU</a>
                <!-- <img class="logo-light" title="" alt="Donart."> -->
            </a>
        </div>
        <!-- / -->
        <ul class="main-menu">
            <li>
                <a class="menu-item"  spyOn="home" activeClass="active"  href="#home" (click)="fullPageScroll('home')">
                    Home
                </a>
            </li>
            <li>
                <a class="menu-item"  spyOn="services" activeClass="active" href="#services" (click)="fullPageScroll('services')">
                    Services
                </a>
            </li>
            <!-- <li>
                <a class="menu-item" spyOn="project" activeClass="active"  href="#project" (click)="fullPageScroll('project')">
                    Projects
                </a>
            </li> -->
            <li>
                <a class="menu-item" spyOn="about" activeClass="active"  href="#about" (click)="fullPageScroll('about')"> 
                    About Me
                </a>
            </li>
            <li>
                <a class="menu-item"  spyOn="contactus" activeClass="active"  href="#contactus" (click)="fullPageScroll('contactus')">
                    Contact
                </a>
            </li>
        </ul>
        <!-- Top Menu -->
        <div class="ms-auto d-flex" (clickOutside)="onClickedOutside($event)">
            <!-- to scroll let's talk to Contact Page change below "href="javascript:" to " spyOn="contactus" href="#contactus" "-->
            <a class="px-btn dark d-none d-lg-inline-flex" href="#contactus">Lets' Talk</a>
            <mat-button class="toggler-menu d-lg-none" [ngClass]="{'open': sidebarOpen}" (click)="toggleMenu()">
                <span></span>
            </mat-button>
        </div>
        <!-- / -->
    </div>
</div>
<!-- End Header -->